import { Button, ButtonProps } from '@chakra-ui/react';
import { ReactComponent as NewFolderIcon } from 'assets/icons/folderNew.svg';
import { ReactElement } from 'react';

interface NewFolderButtonProps {
  text: string;
  isViewOnly?: boolean;
  buttonProps?: ButtonProps;
  iconColor?: string;
  onClick?: () => void;
}

const NewFolderButton = ({
  isViewOnly = false,
  onClick = () => {},
  buttonProps = { variant: 'action', size: 'sm' },
  iconColor = 'white',
  text,
}: NewFolderButtonProps): ReactElement => {
  return (
    <Button
      data-testid='create-folder'
      leftIcon={<NewFolderIcon fill={iconColor} />}
      onClick={onClick}
      disabled={isViewOnly}
      fontWeight={'var(--vg-fontWeights-medium)'}
      {...buttonProps}
    >
      {text}
    </Button>
  );
};
NewFolderButton.displayName = 'NewFolderButton';

export default NewFolderButton;
